import {
  InformalFeedbackRequest,
  InformalFeedbackReview,
  InformalFeedbackReviewDismissReason,
  InformalFeedbackReviewScore,
} from 'api/clients/InformalFeedbackRequestsClient'
import { DismissReviewButton } from './DismissReviewButton'
import { observer } from 'mobx-react-lite'
import { SubmitReviewButton } from './SubmitReviewButton'

interface Props {
  request: InformalFeedbackRequest
  review: InformalFeedbackReview
  isDisabled: boolean
  value: InformalFeedbackReviewScore | InformalFeedbackReviewDismissReason | ''
  message: string
  dueDate?: string
}

export const SubmitButton = observer(({ value, review, request, isDisabled, message, dueDate }: Props) => {
  if (value === InformalFeedbackReviewDismissReason.Declined) {
    return <DismissReviewButton review={review} request={request} isDisabled={isDisabled} message={message} />
  }

  return (
    <SubmitReviewButton
      score={value as InformalFeedbackReviewScore}
      review={review}
      isDisabled={isDisabled}
      message={message}
      request={request}
      dueDate={dueDate}
    />
  )
})
